<template>
  <svg
    :class="size"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5 21.875C17.6777 21.875 21.875 17.6777 21.875 12.5C21.875 7.32233 17.6777 3.125 12.5 3.125C7.32233 3.125 3.125 7.32233 3.125 12.5C3.125 17.6777 7.32233 21.875 12.5 21.875ZM12.2266 16.2652L17.4349 10.0152L15.8984 8.73481L11.3911 14.1436L9.04044 11.7929L7.62623 13.2071L10.7512 16.3321L11.5255 17.1064L12.2266 16.2652Z"
      :fill="$primaryColor"
    />
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: () => 'h-6 w-6'
    }
  }
}
</script>
